import { ChemicalInput } from "generated-graphql/graphql";
import { omit } from "lodash-es";
import { v4 } from "uuid";

import { ChemicalDetailInputs } from "../../routes/Customer/Chemicals/Catalog/Chemical";
import { transform as transformDocument } from "./transformDocument";
import { transform as transformStateField } from "./transformStateField";

export function transform(input: ChemicalDetailInputs): ChemicalInput {
  return {
    // `noHazardsNotReporting` is intentionally stripped — flips happen
    // through the dedicated `setChemicalExcludeFromTierIIReporting` mutation
    // so the audit row attributes the change to that resolver.
    ...omit(input, "__typename", "id", "issues", "verifier", "noHazardsNotReporting"),
    components: input.components?.map((c) => ({
      ...omit(c, "__typename"),
      componentPercentage: parseFloat(String(c.componentPercentage)),
      id: c.id ?? v4(),
    })),
    documents: input.documents?.map((cd) => ({
      ...omit(cd, "chemical"),
      key: cd.key,
      name: cd.name,
      chemicalId: input.id,
      documentId: cd.documentId,
      document: transformDocument(cd.document),
    })),
    density: parseFloat(String(input.density)),
    stateFields: input.stateFields?.map(transformStateField),
  };
}
